<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title" v-if="$route.meta.keepAlive" />
    <router-view v-if="!$route.meta.keepAlive" v-wechat-title="$route.meta.title"></router-view>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
    // 监听APP返回操作
    window.receiveMessage = (msg) => {
      // alert(JSON.stringify(msg))
      if (msg.functionType === '10003') {
        if (window.location.href.includes('home')) {
          this.sendMessageToApp('10002')
        } else {
          this.$router.go(-1)
        }
      }
    }
    // ios后退白屏的问题
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual' // 改为manual之后，就不会记录滚动位置
    }
  },
  methods: {
    sendMessageToApp (type) {
      const data = {
        functionType: type
      }
      window.ReactNativeWebView && window.ReactNativeWebView.postMessage(JSON.stringify(data))
    }
  }
}
</script>

<style lang="less">
// 解决IOS 后退白屏问题 11-06 屏蔽
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  position: relative;
}
#app {
  // width: 100%;
  // height: 100%;
  background: #f6f6f6;
  // overflow: scroll;
  // -webkit-overflow-scrolling: touch;
  // position: absolute;
  // left: 0;
  // top: 0;
}
</style>

